export default __webpack_public_path__ + "static/media/NFT-file-true-2.8414c5d1.png";